/* unplugin-vue-components disabled */import { render } from "./userTermsHK.vue?vue&type=template&id=7e7fdc6d&scoped=true"
import script from "./userTermsHK.vue?vue&type=script&lang=js"
export * from "./userTermsHK.vue?vue&type=script&lang=js"

import "./userTermsHK.vue?vue&type=style&index=0&id=7e7fdc6d&scoped=true&lang=css"

import exportComponent from "E:\\IDEAWorkSpace\\parent-net-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7fdc6d"]])

export default __exports__